/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./n1Card.vue?vue&type=template&id=250e0881&scoped=true&"
import script from "./n1Card.vue?vue&type=script&lang=js&"
export * from "./n1Card.vue?vue&type=script&lang=js&"
import style0 from "./n1Card.vue?vue&type=style&index=0&id=250e0881&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250e0881",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VTooltip})
